import { useState, useEffect } from "react";
import axios from "axios";

const useTokenVerification = () => {
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(null);
  const [isData, setData] = useState(null);

  const verifyToken = async (token) => {
    if (!token) {
      setError("Invalid verification link.");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setData(null);

      const response = await axios.post(
        "https://api.v2vbn.org:8443/api/v1/auth/verifyMember",
        {
          token,
        }
      );

      if (response?.data?.success) {
        console.log("response: ", response);
        setData(response?.data.data);
      } else {
        console.log("response: ", response);
        setError(response?.data?.message);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const verifyVisitorToken = async (token) => {
    if (!token) {
      setError("Invalid verification link.");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setData(null);

      const response = await axios.post(
        `https://api.v2vbn.org:8443/api/v1/visitors/verifyVisitor?token=${token}`
      );

      if (response?.data?.success) {
        console.log("response: ", response);
        setData(response?.data.data);
      } else {
        console.log("response: ", response);
        setError(response?.data?.message);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return { isLoading, isError, isData, verifyToken, verifyVisitorToken };
};

export default useTokenVerification;
